import createReactComponent from '../createReactComponent';
export default createReactComponent(
  'square-rounded-chevron-up',
  'IconSquareRoundedChevronUp',
  [
    ['path', { d: 'M9 13l3 -3l3 3', key: 'svg-0' }],
    [
      'path',
      {
        d: 'M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z',
        key: 'svg-1',
      },
    ],
  ],
);
